 import uly from "ulysses/core";
 import $ from "jquery";
 import ko from "knockout";
 import HalResource from "ulysses/api";
 "use strict";
 ko.bindingHandlers.bin_calc = {
     init: function init_calculator(elt, va, allbindings, model, context) {
         var operator = ko.unwrap(va());
         var x = allbindings().x;
         var y = allbindings().y;
         var z = allbindings().z;

         var op = null, rev_op = null;
         if (operator == "+") {
             op = function add(x,y) { return x+y; };
             rev_op = function sub(x,y) { return x-y; };
         } else if (operator == "*") {
             op = function mul(x,y) { return x*y; };
             rev_op = function div(x,y) { return y == 0 ? 0 : x/y; };
         }
         var calc = false;
         x.subscribe(function(newvalue) {
             if (calc) return;
             calc = true;
             try {
                 z(op(newvalue, ko.unwrap(y)));
             }
             finally {
                 calc = false;
             }
         });
         y.subscribe(function(newvalue) {
             if (calc) return;
             calc = true;
             try {
                 z(op(ko.unwrap(x), newvalue));
             }
             finally {
                 calc = false;
             }
         });
         z.subscribe(function(newvalue) {
             if (calc) return;
             calc = true;
             try {
                 y(rev_op(newvalue, ko.unwrap(x)));
             }
             finally {
                 calc = false;
             }
         });
     }
 };

 ko.virtualElements.allowedBindings.bin_calc = true;

 ko.bindingHandlers.currencycalc = {
      init: function init_calculator(elt, va, allbindings, model, context) {
          var price = allbindings().price;
          var qty = allbindings().qty;
          var discount = allbindings().discount;
          var total = allbindings().total;

          var calc = false;
          if (price) {
              price.native.subscribe(function(newvalue) {
                  if (calc) return;
                  calc = true;
                  try {
                      total.native(newvalue*ko.unwrap(qty)- ((discount && discount.native) ? ko.unwrap(discount.native) : 0));
                      total.foreign(total.native() * (total.rate() || 1.0));
                  }
                  finally {
                      calc = false;
                  }
              });
          }
          if (qty) {
              qty.subscribe(function(newvalue) {
                  if (calc) return;
                  calc = true;
                  try {
                      total.native(ko.unwrap(price.native)*newvalue- ((discount && discount.native) ? ko.unwrap(discount.native) : 0));
                      total.foreign(total.native() * (total.rate() || 1.0));
                  }
                  finally {
                      calc = false;
                  }
              });
          }
          if (discount && discount.native) {
              discount.native.subscribe(function(newvalue) {
                  if (calc) return;
                  calc = true;
                  try {
                      total.native(ko.unwrap(price.native)*ko.unwrap(qty)- newvalue);
                      total.foreign(total.native() * (total.rate() || 1.0));
                  }
                  finally {
                      calc = false;
                  }
              });
          }
          
          total.native.subscribe(function(newvalue) {
              if (calc) return;
              calc = true;
              try {
                  price.native(ko.unwrap(qty) ? ((newvalue + ((discount && discount.native) ? ko.unwrap(discount.native) : 0.0))/ko.unwrap(qty)) : null);
                  price.foreign(price.native() * (total.rate() || 1.0));
              }
              finally {
                  calc = false;
              }
          });
      }
  };

 ko.virtualElements.allowedBindings.currencycalc = true;

